import {Tr} from "@/i18n/i18n";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {StringUtils} from "@/utils/string-utils";
import {CreatureUtils} from "@/utils/creature-utils";
import {ForceBasePanel} from "@/scenes.ui/force-base-panel";
import PlayerStore from "@/store/player";
import {Lang} from "@/store/player/types";
import {WarriorClass} from "@/store/level/types";
import {LevelsInfo} from "@/store/creature/types";
import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;

export class MainForcePanel extends ForceBasePanel {

    private static INNER_BAR_WIDTH: number = 294;

    constructor(scene: Scene, canvas: HTMLCanvasElement, li: LevelsInfo, warriorClass:WarriorClass, currentLevel:number, slotX: number, slotY: number, container: Container, callback: ()=>void) {
        super(scene, canvas, slotX, slotY, container);

        let forceName = PlayerStore.getPlayer().lang == Lang.RU ?
            StringUtils.capitalizeFirstLetter(Tr('force')) + ' ' + StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(warriorClass)) :
            StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(warriorClass)) + ' ' + StringUtils.capitalizeFirstLetter(Tr('force'));

        const title = TextUtils.addTextByFamily(this.scene, forceName, 0, -278, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let levelText = TextUtils.addTextByFamily(scene, Tr('rang') + " " + String(Math.min(li.levels.length, currentLevel)),
            0, -223, '#ffedc6', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let blackZone = SpriteUtils.addSprite(this.scene, 0, -150+2, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_ZONE, 0.95, 1.7);
        const imageLiner = SpriteUtils.addImage(this.scene, 0 - 4, -150 + 6, Keys.ATLAS_UI, Keys.UI_BADGE_LINER, 1.1);
        imageLiner.alpha = 0.7;
        let item = SpriteUtils.addSprite(this.scene, 0, -150,
            CreatureUtils.getForceAtlasLarge(warriorClass), CreatureUtils.getLargeForceIcon(warriorClass, true), 0.8);

        let info = li.levels[Math.min(li.levels.length-1, li.level - 1)];
        let forceInfoLabel = TextUtils.addTextAdvanced(scene, info.description, 0, -22,
            '#d7d7d7', 13, 'normal', 300, 'center', 2, Fonts.ARIAL_MT);
        forceInfoLabel.setOrigin(0.5, 0.5);

        let isMaxRank = li.level >= li.levels.length;
        let notUpgradableClasses = [WarriorClass.WARLOCK, WarriorClass.TITAN, WarriorClass.ARCHITITAN, WarriorClass.ANGEL,
            WarriorClass.ARCHANGEL, WarriorClass.ASG_PHOENIX, WarriorClass.YOTUN];
        let isUpgradable = !notUpgradableClasses.includes(warriorClass);

        let blackZone3 = SpriteUtils.addSprite(this.scene, 0, 50, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_ZONE, 0.95, 3.60);
        blackZone3.setOrigin(0.5, 0);
        let barScaleY = 0.8;

        let outerBar = SpriteUtils.addImage(this.scene, -120, 60, Keys.ATLAS_UI, Keys.UI_TASK_PROGRESS_BAR_OUTER, 0.8, barScaleY)
            .setOrigin(0, 0);

        let innerBar = SpriteUtils.addImage(this.scene, outerBar.x / CU.S + 3, outerBar.y / CU.S + 4, Keys.ATLAS_UI, Keys.UI_TASK_PROGRESS_BAR_INNER, 1, barScaleY)
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(innerBar, MainForcePanel.INNER_BAR_WIDTH * (li.doneCount / li.requiredCount) * 0.8, 22);

        let completedText = TextUtils.addTextAdvanced(scene, Tr('dobivaniy').toUpperCase() + ' ' + Tr('to.the') +  ' ' + (li.level + 1)  + ' ' +
            Tr('ranga') + ':\n' + li.doneCount + '/' + li.requiredCount, 0, innerBar.y / CU.S + 45,
            '#9a989b', 11, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);
        completedText.setLineSpacing(6);

        outerBar.setVisible(!isMaxRank && isUpgradable);
        innerBar.setVisible(!isMaxRank && isUpgradable);
        completedText.setVisible(!isMaxRank && isUpgradable);

        let maxLevelLabel = TextUtils.addTextAdvanced(scene, Tr('sila.na.maksimalnom.urovne'), 0, 93,
            '#716f6a', 12, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        maxLevelLabel.setVisible(isMaxRank && isUpgradable);

        let notUpgradableLabel = TextUtils.addTextAdvanced(scene, Tr('can.not.improve.rank'), 0, 93,
            '#716f6a', 12, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        notUpgradableLabel.setVisible(!isUpgradable);

        let okButton = new SquareButton(this.scene, 0, 192, 0,
            Keys.UI_ART_BROWN_BUTTON, undefined, Keys.UI_MANUAL_QUESTION_GREEN, Tr('det'), false);

        okButton.setScale(0.9, 0.9)

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                this.close();
                callback();
            }
        });

        this.add([title, levelText, blackZone, blackZone3,imageLiner, item, forceInfoLabel, maxLevelLabel, notUpgradableLabel,
             okButton, outerBar, innerBar, completedText, okButton]);
    }
}
